module.exports = __webpack_public_path__ + "img/清华.75d5dac2.png";